export const getUnitPrice = (item) => {
  const basePrice = Number(item.product?.price) || 0;
  const optionPrice = Number(item.productOption?.extraPrice) || 0;

  return optionPrice > 0 ? optionPrice : basePrice;
};

export const getProductDeal = (product) => {
  return product?.deals?.[0] || product?.Deals?.[0] || null;
};

export const calculateItemTotal = (item) => {
  const unitPrice = getUnitPrice(item);
  const amount = Number(item.amount) || 0;
  const deal = getProductDeal(item.product);

  if (!deal) return unitPrice * amount;

  const dealType = Number(deal.dealType ?? deal.DealType);
  const quantity = Number(deal.quantity ?? deal.Quantity);
  const dealPrice = Number(deal.dealPrice ?? deal.DealPrice);
  const discountPercent = Number(
    deal.discountPercent ?? deal.DiscountPercent
  );

  // 1 = BuyXGetOneFree = X+1 חינם
  // לדוגמה: quantity = 2 אומר 2+1 חינם
  if (dealType === 1 && quantity > 0) {
    const groupSize = quantity + 1;
    const freeItems = Math.floor(amount / groupSize);
    return (amount - freeItems) * unitPrice;
  }

  // 2 = XForPrice = X מוצרים במחיר קבוע
  // לדוגמה: 3 ב־10 ש"ח
  if (dealType === 2 && quantity > 0 && dealPrice > 0) {
    const groups = Math.floor(amount / quantity);
    const rest = amount % quantity;
    return groups * dealPrice + rest * unitPrice;
  }

  // 3 = PercentDiscount = אחוז הנחה
  if (dealType === 3 && discountPercent > 0) {
    return unitPrice * amount * (1 - discountPercent / 100);
  }

  return unitPrice * amount;
};

export const calculateCartTotal = (cart) => {
  return Number(
    cart.reduce((sum, item) => sum + calculateItemTotal(item), 0).toFixed(2)
  );
};